import React from 'react';

// This component can be used to wrap any Parallax element that emits a form submit event.
// When using Parallax components within a Formik form, the form submit event may be triggered
// by Parallax when it is not needed. This can cause unexpected behavior.
const PreventSubmitWrapper = ({ children }: { children: React.ReactNode }) => {
  const preventSubmit = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <div onClick={preventSubmit} style={{ display: 'contents' }}>
      {children}
    </div>
  );
};

export default PreventSubmitWrapper;
